module.exports = __webpack_public_path__ + "img/4_1.98229a6a.png";